import Cookies from 'js-cookie';

export enum cookieKey {
  UserSettingTabHistory = 'userSettingTabHistory',
  UserToken = 'userToken',
  UserData = 'userData',
  AnonymousName = 'anonymousName',
  AnonymousPassword = 'anonymousPassword',
  UserAlertToken = 'userAlertToken',
  ShowSeries = 'showSeries',
  ThemeSet = 'themeSet',
  PageOffset = 'pageOffset',
  PageScrollY = 'pageScrollY',
  DocID = 'docID',
  DocIndex = 'docIndex',
}

export const cookieStore = {
  // user  -------------------------------
  setUserToken(token) {
    Cookies.set(cookieKey.UserToken, token, { expires: 30 });
  },
  getUserToken() {
    return Cookies.get(cookieKey.UserToken);
  },

  // userData ------------------------------
  // data: {
  //  uid: string;
  //  email: string;
  //  password: string;
  //}
  setUserData(data) {
    Cookies.set(cookieKey.UserData, data);
  },
  getUserData() {
    return Cookies.get(cookieKey.UserData);
  },

  // themeSet ----------------------------------
  setPostTheme(key, data) {
    Cookies.set(key, data, { expires: 1 });
  },
  getPostTheme(key) {
    return Cookies.get(key);
  },
  removePostTheme(key) {
    Cookies.remove(key);
  },

  // posting series open ----------------------------
  setShowSeries(set: '0' | '1') {
    Cookies.set(cookieKey.ShowSeries, set, { expires: 30 });
  },
  getShowSeries() {
    return Cookies.get(cookieKey.ShowSeries);
  },

  // posting save offset ------------------------------
  setOffset(offset: '0') {
    Cookies.set(cookieKey.PageOffset, offset);
  },
  getOffset() {
    return Cookies.get(cookieKey.PageOffset);
  },
  removeOffset() {
    Cookies.remove(cookieKey.PageOffset);
  },

  // scrollY -------------------------
  setPageScrollY(pageScrollY) {
    Cookies.set(cookieKey.PageScrollY, pageScrollY);
  },
  getPageScrollY() {
    return Cookies.get(cookieKey.PageScrollY);
  },
  removePageScrollY() {
    Cookies.remove(cookieKey.PageScrollY);
  },

  // docIndex -------------------------------------
  setDocID(docId) {
    Cookies.set(cookieKey.DocID, docId);
  },
  getDocID() {
    return Cookies.get(cookieKey.DocID);
  },
  removeDocID() {
    Cookies.remove(cookieKey.DocID);
  },

  // fcm -------------------------------
  setUserAlertToken(token) {
    Cookies.set(cookieKey.UserAlertToken, token, { expires: 30 });
  },
  getUserAlertToken() {
    return Cookies.get(cookieKey.UserAlertToken);
  },

  // anonymous -------------------------------
  setAnonymous(name, password) {
    Cookies.set(cookieKey.AnonymousName, name, { expires: 30 });
    Cookies.set(cookieKey.AnonymousPassword, password, { expires: 30 });
  },
  getAnonymousName() {
    return Cookies.get(cookieKey.AnonymousName);
  },
  getAnonymousPassword() {
    return Cookies.get(cookieKey.AnonymousPassword);
  },
  removeAnonymous() {
    Cookies.remove(cookieKey.AnonymousName);
    Cookies.remove(cookieKey.AnonymousPassword);
  },

  // tab history  --------------------------
  setTabHistory(key, value: string) {
    Cookies.set(key, value, { expires: 30 });
    Cookies.set(key, value, { expires: 30 });
  },
  getTabHistory(key) {
    return Cookies.get(key);
  },
  removeTabHistory(key) {
    Cookies.remove(key);
  },

  // clear -------------------------------
  clearTokens(all?: boolean) {
    Cookies.remove(cookieKey.UserToken);
    Cookies.remove(cookieKey.UserData);
    Cookies.remove(cookieKey.UserAlertToken);
    Cookies.remove(cookieKey.UserSettingTabHistory);

    if (all) {
      // 익명 관련 쿠키도 삭제
      Cookies.remove(cookieKey.AnonymousName);
      Cookies.remove(cookieKey.AnonymousPassword);
      // 네비게이션 관련 쿠키
      Cookies.remove(cookieKey.PageOffset);
      Cookies.remove(cookieKey.PageScrollY);
      Cookies.remove(cookieKey.DocID);
    }
  },
};
